/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Started_TodayInputs */

const en_task_started_today = /** @type {(inputs: Task_Started_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Started today`)
};

const pt_br2_task_started_today = /** @type {(inputs: Task_Started_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciado hoje`)
};

/**
* | output |
* | --- |
* | "Started today" |
*
* @param {Task_Started_TodayInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_started_today = /** @type {((inputs?: Task_Started_TodayInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Started_TodayInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_started_today(inputs)
	return pt_br2_task_started_today(inputs)
});